@if (showBreadcrumb) {
    <div class="breadcrumbs d-flex w-100 align-items-center">
        <div class="breadcrumbs-content flex-grow-1 px-0 px-md-3">
            @if (((breadcrumbs && breadcrumbs.length) || 0) > 0) {
                <ul class="breadcrumbs-breadcrumb d-flex flex-row flex-wrap m-0 mt-1 p-0 list-unstyled">
                    @for (
                        breadcrumb of breadcrumbs;
                        track breadcrumbIndex;
                        let breadcrumbIndex = $index;
                        let last = $last
                    ) {
                        <li class="breadcrumbs-breadcrumb-item {{ breadcrumb.class }}">
                            <a
                                class="breadcrumbs-breadcrumb-section m-0 pe-1 text-nowrap mat-subtitle-2 d-flex"
                                [routerLink]="[breadcrumb.link]"
                            >
                                {{ breadcrumb.section | uppercase }}
                                @if (!last) {
                                    <span> &nbsp; / </span>
                                }
                            </a>
                        </li>
                    }
                </ul>
            }
        </div>
    </div>
}
